import {useNavigate} from 'react-router'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {
  TNotification,
  notificationSelector,
  setAmount,
  setNotification,
} from 'src/redux/slices/notificationSlices'
import {fetchNotification} from 'src/services/fetcher'
import dateformat from 'src/utils/dateformat'
import styled from 'styled-components'
import swal from 'sweetalert'
import {useNotificationFetcher} from '../../hooks/useNotificationFetcher'
import {setItemNego} from 'src/_metronic/redux/content'

interface NotificationItemProps {
  item: TNotification
}

const StyledNofificationItem = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 0.7rem;
  justify-content: start;
  align-items: start !important;
`

export const NotificationItem = ({item}: NotificationItemProps) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const {amount} = useAppSelector(notificationSelector)
  const {handleFetchUnreadNotifications} = useNotificationFetcher()

  const handleClick = async () => {
    try {
      dispatch(setNotification(item))
      dispatch(setAmount(amount - 1))
      handleFetchUnreadNotifications()

      // Reqeuest notification detail as mark the notification to be read
      await fetchNotification(item.id)

      switch (item.type) {
        // Redirect kehalaman detail findoc
        case 'findoc':
          const id = (item.parent_id || item.child_id)?.toString() ?? ''
          sessionStorage.setItem('id', id)
          navigate('/financial/detail')
          break

        // Redirect kehalaman negosiasi detail (popup)
        case 'negotiation':
          dispatch(
            setItemNego({
              id: item.parent_id,
              type: item.flag_nego === 'header' ? 'multiple' : 'single',
              url: '/management/order/all',
              flag: item.flag_nego,
              customer_id: item.user?.customer_code || item.user.id,
              header_id: item.header_id || null,
              parent_id: item.parent_id,
              role_flag: item.role_flag,
            })
          )
          navigate('/negotiate')
          break

        // Reedirect kehalaman orders, lalu buka popup chat untuk order tesebut
        case 'order_sub_header':
          let headerId = parseInt(item.parent_id.substring(2)).toString();
          sessionStorage.setItem('po', headerId)
          navigate('/management/order/detail/' + headerId)
          break

        // Reedirect kehalaman orders, lalu buka popup order-item untuk order tesebut
        case 'order_submission':
          let orderId = parseInt(item.parent_id.substring(2)).toString();
          sessionStorage.setItem('po', orderId)
          navigate('/management/order/detail/' + orderId)
          break

        // Redirect kehalaman so detail
        case 'sales-order':
          let soId = parseInt(item.parent_id.substring(2)).toString();
          sessionStorage.setItem('id', soId)
          navigate('/management/so/detail/' + soId)
          break

        // Redirect kehalaman sip detail
        case 'sip':
          let sipId = parseInt(item.parent_id.substring(2)).toString();
          sessionStorage.setItem('SI_ID', sipId)
          navigate('/management/sip/detail/' + sipId)
          break

        // Redirect kehalaman contract detail
        case 'contract':
          let kId = parseInt(item.parent_id.substring(2)).toString();
          sessionStorage.setItem('kid', kId)
          navigate('/management/kontrak/detail/' + kId)
          break

        default:
          break
      }
    } catch (error: any) {
      swal({title: 'Error', text: error?.message ?? 'error'})
    }
  }

  return (
    <div className='menu-item px-4'>
      <StyledNofificationItem className='menu-link' onClick={handleClick}>
        <div className='font-bold'>{item?.title ?? '-'}</div>
        <div className='fw-normal text-truncate' style={{maxWidth: '99%'}}>
          {item?.body ?? '-'}
        </div>
        <div className='text-muted fw-light fs-7'>{dateformat(item.created_at)}</div>
      </StyledNofificationItem>
    </div>
  )
}
